import React from 'react';
import { Flag } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/flag.less';

export default Flag;
